import { useDropdownController } from '@cat-ecom/pcc-components/src/hooks/form-controllers';
import { GuestDropDownFormProps } from './types';
import GuestDropDownSharedForm from './Guest-Drop-Down-Shared-Form';

export const GuestDropDownForm = (props: GuestDropDownFormProps) => {
  const { dropdownField } = useDropdownController({
    name: props.name,
    rules: props.rules
  });

  return <GuestDropDownSharedForm dropdownField={dropdownField} {...props} />;
};
